// removed by extract-text-webpack-plugin
module.exports = {"contactPage":"gE9Xlga0hWCzn3Ucg4iI-","content":"_3HUy_Csm6Ss8eVxVuy8eaA","ourContacts":"_1WrLfuAHbweOwXMfqVjRQ1","contactItem":"yf8jn7SHd5Xy2u6D6bTNG","native":"_3W_D4kyEObXTEKZZfa7RQI"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/ContactUsPage/ContactUsPage.scss
// module id = 1856
// module chunks = 0